/** Only same-origin paths are accepted as a post-login target. */
export function safeRedirect(r: unknown): string {
  return typeof r === "string" && r.startsWith("/") && !r.startsWith("//") ? r : "/";
}
